import { list, Filter } from "@mc/mc-legacy";
import QsignPrehledApi from "../api/gen/qsign/QSignPrehledApi";
export const OVERVIEW = "overview";
export function fetchIfNeeded() {
  return (dispatch) => {
    dispatch(
      list.SimpleListActions.fetchIfNeeded(OVERVIEW, 0, (parent, filter) => QsignPrehledApi.findOverview(filter))
    );
  };
}
export function invalidate() {
  return (dispatch) => {
    dispatch(list.SimpleListActions.invalidate(OVERVIEW, 0));
  };
}

const purify = ({ dateRange, ...filter }) => {
  return { ...filter, dateRange: dateRange ? dateRange : null };
};

export function filter(filter) {
  const { ...otherFilterFields } = Filter.purifyValues(filter);
  return (dispatch) => {
    dispatch(list.SimpleListActions.filter(OVERVIEW, purify(otherFilterFields)));
  };
}
